import type { SupportFormValues } from '../../../types/support';

const DRAFT_KEY = 'pa:support-draft';

const safe = <T>(fn: () => T, fallback: T): T => {
    try {
        return fn();
    } catch {
        return fallback;
    }
};

export const loadSupportDraft = (): Partial<SupportFormValues> | null =>
    safe(() => {
        const raw = sessionStorage.getItem(DRAFT_KEY);
        if (!raw) return null;

        const parsed = JSON.parse(raw) as Partial<SupportFormValues>;
        return typeof parsed === 'object' && parsed !== null ? parsed : null;
    }, null);

export const saveSupportDraft = (values: SupportFormValues): void =>
    safe(() => sessionStorage.setItem(DRAFT_KEY, JSON.stringify(values)), undefined);
